import shop from "shop/shop"

export default class CategoryModel {
	constructor( data ) {
		this.validate( data )
		addImageLinks( data )
		Object.assign( this, data )
		this.cssClass = "cat-" + data.map_id
		this.desc = this.desc || {}
		this.title = this.desc.short_des || "NOT SET"
		this.title = this.title.trim()
		this.description = this.desc.des || "NOT SET"
		this.description = this.description.trim()

		this.active = true

		this.meta = data.meta || {}
		this.meta.submeta = this.meta.submeta || {}
		this.meta.submeta.fields = this.meta.submeta.fields || {}

	}

	update() {
		// NOOP
	}

	getCategories() {
		let catIds = this.getParents()
		return catIds.map( categoryId => {
			let category = shop.categoriesById.get( categoryId )
			return category
		} )
	}

	getParents() {
		return getParents( this )
	}

	validate() {
		if ( !this.desc || !this.desc.des ) {
			this.desc = this.desc || {}
			this.desc.des = "NOT SET"
			this.desc.short_des = "NOT SET"
		}
		return true
	}
}

const getParents = ( category ) => {
	let ttl = 10
	let parents = []
	while ( category && category.parent && ttl-- ) {
		parents.push( category.parent )
		category = shop.categoriesById.get( category.parent )
	}
	return parents.reverse()
}


const addImageLinks = function ( data = {} ) {
	let config = window.__bshop_config // this will break.
	if ( data && data.map_pic_id ) {
		const encodedPictureId = encodeURIComponent( data.map_pic_id )
		// prepare img source
		data.img_src = config.MEDIA + "description/" + encodedPictureId + "/1?size=large"
		data.img_src_small = config.MEDIA + "description/" + encodedPictureId + "/1?size=small"
		data.img_src_medium = config.MEDIA + "description/" + encodedPictureId + "/1?size=middle"
		data.img_src_large = config.MEDIA + "description/" + encodedPictureId + "/1?size=large"
		data.img_srcs = []
	} else {
		data.img_src = "/image/placeholder.png"
		data.img_src_small = "/image/placeholder.png"
		data.img_src_medium = "/image/placeholder.png"
		data.img_src_large = "/image/placeholder.png"
		data.img_srcs = []
	}
	return data
}



// WEBPACK FOOTER //
// ./src/sdk/CategoryModel.js